import { ComingSoonTrafficSource } from '../../../../../shared/components/dialogs/coming-soon-dialog/coming-soon-traffic-source';
import { RedeAdsEnum } from '../../../../../shared/enum/rede-ads.enum';
import { REDE_ADS_CATALOG } from '../../../../../shared/rede-ads/rede-ads.registry';

export type ManagementAdsNavItem = {
    redeAds: RedeAdsEnum;
    route: string;
    labelKey: string;
    iconSrc: string;
    comingSoonSource: ComingSoonTrafficSource | null;
};

export const MANAGEMENT_ADS_BASE_PATH = '/v2/analytics/management-ads';

const MANAGEMENT_ADS_NAV_LABEL_KEY: Record<RedeAdsEnum, string> = {
    [RedeAdsEnum.GOOGLE_ADS]: 'menu.nav.googleAds',
    [RedeAdsEnum.META_ADS]: 'menu.nav.metaAds',
    [RedeAdsEnum.NEWSBREAK]: 'menu.nav.newsbreakAds',
    [RedeAdsEnum.TABOOLA]: 'menu.nav.taboolaAds',
    [RedeAdsEnum.TIK_TOK]: 'menu.nav.tiktokAds',
    [RedeAdsEnum.MGID]: 'menu.nav.mgidAds',
    [RedeAdsEnum.REVCONTENT]: 'menu.nav.revcontentAds',
};

const MANAGEMENT_ADS_COMING_SOON_SOURCE: Partial<Record<RedeAdsEnum, ComingSoonTrafficSource>> = {
    [RedeAdsEnum.TIK_TOK]: 'tiktok',
    [RedeAdsEnum.MGID]: 'mgid',
    [RedeAdsEnum.REVCONTENT]: 'revcontent',
};

export const MANAGEMENT_ADS_NAV_ITEMS: readonly ManagementAdsNavItem[] = REDE_ADS_CATALOG.map((entry) => ({
    redeAds: entry.id,
    route: `${MANAGEMENT_ADS_BASE_PATH}/${entry.slug}`,
    labelKey: MANAGEMENT_ADS_NAV_LABEL_KEY[entry.id],
    iconSrc: entry.iconPath,
    comingSoonSource: MANAGEMENT_ADS_COMING_SOON_SOURCE[entry.id] ?? null,
}));
